import { isArray, isClient } from '@qcwp/utils'
import type { Fn } from '@vueuse/core'
import { ARTICLE_TYPE, LOAD_STATUS } from '@qcwp/common'
import { useGetRouteParam } from '~~/src/common/function/url'
import type { ShareBase } from '~~/src/composables/useShare'
import { LogicArticleDetail, useArticleHandle } from '~~/src/logic/article/detail'
import { callWithNuxt } from '#app'
// import { preDataGetHandler } from '~~/src/logic/article/detail/match'

export function useArticleDetailPage(type: ARTICLE_TYPE = ARTICLE_TYPE.PICTURE) {
  const nuxtApp = useNuxtApp()
  const $bus = useNuxtApp().$bus as any
  // 资讯id
  const articleId = useGetRouteParam('articleId', 'string')
  // detail info
  const {
    isAuthor,
    status,
    detail,
    detailType,
    siteMeta,
    media,
    shareBase,
    serverHandler: getArticleDetail,
    bindTopicsServerHandler,
  } = LogicArticleDetail()
  // handle
  const { starHandle: starHandleReq } = useArticleHandle()
  // 收藏
  async function starHandle() {
    if (!detail.value)
      return
    const result = await starHandleReq(articleId.value, detail.value?.collect)
    if (result)
      detail.value.collect = !detail.value.collect
  }
  // 关注
  async function mediaRecommendAttentionStatusChange(_status: boolean) {
    if (detail.value)
      detail.value.focus = !detail.value?.focus
  }
  // 评论数变化
  function changeCommentCount(data: number) {
    if (data && !isNaN(Number(data)) && detail.value)
      detail.value.commentCount = data
  }

  // To comment list
  const detailComponentRef = ref()
  function commentClickHandle() {
    if (detailType.value && detailType.value === ARTICLE_TYPE.VIDEO)
      detailComponentRef.value && detailComponentRef.value.changeActive?.(1)
    else
      commentClick('comment-list')
  }

  async function initHandle() {
    if (isNaN(Number(unref(articleId)))) {
      status.value = LOAD_STATUS.NULL
      return
    }

    const promises: any[] = [
      callWithNuxt(nuxtApp, getArticleDetail, [unref(articleId)]),
      // type === ARTICLE_TYPE.PICTURE ? callWithNuxt(nuxtApp, preDataGetHandler) : null,
    ]
    await Promise.all(promises)

    if (type === ARTICLE_TYPE.PICTURE && detail.value && detail.value.matchSeries && detail.value.porArticleCarRefList?.length) {
      const content = detail.value.articleDetailInfoVO.articleContent
      detail.value.articleDetailInfoVO.articleContent = detail.value.matchSeries(content, detail.value.porArticleCarRefList)
    }

    if (detail.value?.bindTopic) {
      const params = { dataId: detail.value.id, dataType: detail.value.articleType }
      detail.value.bindTopics = await callWithNuxt(nuxtApp, bindTopicsServerHandler, [params])
    }
  }

  onActivated(() => {
    $bus.off('COMMENT_COUNT_CHANGE')
    $bus.on('COMMENT_COUNT_CHANGE', changeCommentCount)
  })
  onDeactivated(() => {
    $bus.off('COMMENT_COUNT_CHANGE')
  })
  onMounted(() => {
    $bus.off('COMMENT_COUNT_CHANGE')
    $bus.on('COMMENT_COUNT_CHANGE', changeCommentCount)
  })
  onUnmounted(() => {
    $bus.off('COMMENT_COUNT_CHANGE')
  })
  return {
    articleId,
    // detail info
    isAuthor,
    status,
    detail,
    detailType,
    siteMeta,
    media,
    shareBase,
    // To comment list
    commentClick,
    initHandle,
    // 收藏
    starHandle,
    // 关注
    mediaRecommendAttentionStatusChange,
    // to comment list
    detailComponentRef,
    commentClickHandle,
  }
}
export function commentClick(idSelector = 'comment-textarea') {
  if (!isClient)
    return
  const top = document.getElementById(idSelector)?.offsetTop
  top && window.scrollTo({ top })
}

export const shareBase: ShareBase = {
  url: isClient ? window.location.href : '',
  title: '汽车网评',
  content: '汽车网评汽车网评汽车网评汽车网评汽车网评汽车网评',
  images: ['http://localhost:3000/news/444', 'http://localhost:3000/news/444'],
}

export function useVideoDetailMobileOrTabletComponent() {
  const { isMobileOrTablet } = useDevice()
  const active = ref(0)
  const carTestDriveRef = ref()
  const recommendRef = ref()
  const commentRef = ref()
  const itemsRef = computed(() => [carTestDriveRef.value, recommendRef.value, commentRef.value])
  const itemsContainerRef = ref()
  const itemsTabsRef = ref()
  let eventCleanup: Fn | null = null
  function addEventScroll() {
    let cleanup: Fn | null = null

    if (itemsRef.value && isArray(itemsRef.value)) {
      cleanup = useEventListener(itemsContainerRef, 'scroll', () => {
        const containerOffsetTop = itemsContainerRef.value?.offsetTop || 0
        const items = itemsRef.value
        let newActive = 0
        for (const index in items) {
          const itemTop = items[index].getBoundingClientRect().top
          if (itemTop <= containerOffsetTop + 100)
            newActive = parseInt(index)
          else
            break
        }
        active.value = newActive
      }, { passive: true })
    }
    return cleanup
  }
  function changeActive(data: number) {
    if (!itemsContainerRef.value)
      return

    const el = itemsRef.value[data]
    const tabsHeight = itemsTabsRef.value?.clientHeight || 40
    const top = el.offsetTop - itemsContainerRef.value.offsetTop - tabsHeight
    itemsContainerRef.value && itemsContainerRef.value.scrollTo({ top })
  }
  if (isMobileOrTablet) {
    onActivated(() => {
      eventCleanup && eventCleanup?.()
      eventCleanup = addEventScroll()
    })
    onDeactivated(() => {
      eventCleanup && eventCleanup?.()
    })
    onMounted(() => {
      eventCleanup && eventCleanup?.()
      eventCleanup = addEventScroll()
    })
    onBeforeUnmount(() => {
      eventCleanup && eventCleanup?.()
    })
  }

  return {
    active,
    carTestDriveRef,
    recommendRef,
    commentRef,
    itemsContainerRef,
    itemsTabsRef,
    changeActive,
  }
}
